import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IZilla {
zilla_id:number,
zilla_name:string,
vibhag_id:number,
seq_no:number,
is_active:boolean
}

interface IZillaData {
    list?: Array<IZilla>;
    pageNo: number;
    pageSize: number;
    searchKey?: string;
    totalCount?: number;
    message?: string;
}

const initialState: IZillaData = {
    pageNo: 1,
    pageSize: 20,
    searchKey: '',
    list: [],
    totalCount: 0,
    message: '',
};

const zillaSlice = createSlice({
    name: "zilla",
    initialState,
    reducers: {
        setZillaList: (state, _action: PayloadAction<IZillaData>) => {
            state.list = _action.payload.list;
            state.pageNo = _action.payload.pageNo;
            state.pageSize = _action.payload.pageSize;
            state.totalCount = _action.payload.totalCount;
        },
        resetZillaToInit: (state) => {
            state = initialState;
        },
        setZillaMessage: (state, _action: PayloadAction<string>) => {
            state.message = _action.payload;
        },
    },
});

export const { setZillaList, resetZillaToInit, setZillaMessage } = zillaSlice.actions;

export default zillaSlice.reducer;

